export default __webpack_public_path__ + "maps-examples-view-annotation-marker-thumbnail-960-b09f35075eb8b996e93adb007787907e.png";